export const LISTEN_TO_MY_PROFILE = "LISTEN_TO_MY_PROFILE ";
export const LISTEN_TO_MY_MEMBER_PROFILE = "LISTEN_TO_MY_MEMBER_PROFILE ";
export const LISTEN_TO_MY_PROFILE_INITIATIVES =
  "LISTEN_TO_MY_PROFILE_INITIATIVES ";
export const LISTEN_TO_MY_PROFILE_OKRS = "LISTEN_TO_MY_PROFILE_OKRS ";
